
export function validate(schema, data) {
    const result = schema.validate(data, {abortEarly: false});

    if(!result.error) return null

    const errors = {}
    for (const item of result.error.details) {
        errors[item.path[0]] = item.message
    }
    return errors
}